// Configuração centralizada das URLs da API
export const API_CONFIG = {
  // URL base da API
  BASE_URL: process.env.REACT_APP_API || 'https://insigneacademica.com.br/api/',
  
  // URL base do frontend
  FRONTEND_URL: process.env.REACT_APP_MAIN || 'https://insigneacademica.com.br/editora-insigne/',

  // Endpoints específicos
  ENDPOINTS: {
    // Ebooks
    EBOOK: 'ebook/',
    EBOOK_BY_ID: (id) => `ebook/${id}`,
    EBOOKS_RECENTES: 'ebooks-recentes',
    POPULAR_EBOOKS: 'popular-ebooks',
    
    // Categorias
    CATEGORIAS: 'categorias',
    
    // Autores
    AUTOR: (id) => `autor/${id}`,
    AUTORES: 'autores',
    
    // Arquivos públicos
    PUBLIC: (filename) => `public/${filename}`,
    
    // PDFs
    GET_PDF: 'get-pdf',
    GET_PDF_PREVIEW: (pdfPath) => `get-pdf-preview?pdf_path=${pdfPath}`,
    
    // Pedidos
    PEDIDO_EDITORA: 'pedido-editora',
    PEDIDO_EDITORA_USER_ID: (userId) => `pedido-editora-usuario-id/${userId}`,
    
    // Usuário Editora
    USUARIO_EDITORA: {
      BASE: 'api/usuario-editora',
      STATUS_PAGBANK: 'api/usuario-editora/status-pagbank',
      VALIDATE: 'api/usuario-editora/validate-usuario-editora',
      DADOS: 'api/usuario-editora/dados-usuario-editora',
      COINS: 'api/usuario-editora/coins-usuario-editora',
      LIVROS: 'api/usuario-editora/livros-usuario-editora',
      GET_PDF: (bookId, pdfPath) => `api/usuario-editora/get-pdf?book_id=${bookId}&pdf_path=${pdfPath}`,
      DASHBOARD_AUTOR: 'api/usuario-editora/dashboard-autor'
    },
    
    // PagBank
    AUTHORIZE_SMS: 'authorizeSms',
    OBTER_ACCESS_TOKEN: 'obterAccessToken'
  }
};

// Funções auxiliares para construir URLs completas
export const buildApiUrl = (endpoint) => {
  return `${API_CONFIG.BASE_URL}${endpoint}`;
};

export const buildPublicUrl = (filename) => {
  return buildApiUrl(API_CONFIG.ENDPOINTS.PUBLIC(filename));
};

export const buildFrontendUrl = (path) => {
  return `${API_CONFIG.FRONTEND_URL}${path}`;
};

// Para compatibilidade com código existente
export const API_URL = API_CONFIG.BASE_URL;
export const FRONTEND_URL = API_CONFIG.FRONTEND_URL; 